// extracted by mini-css-extract-plugin
module.exports = {"comp":"ModuleA_comp__R9nA5"};